module.exports = __webpack_public_path__ + "static/assets/31aae4c8caaf429734568a8f51c0f918.svg";